import { Directive, input } from '@angular/core';

@Directive({
  selector: '[fColumnChooserDisabledColumn]',
  standalone: true
})
export class FireflyColumnChooserDisabledColumnDirective {
  field = input.required<string>();
  disabled = input<boolean>(false);
  disabledColumnTitle = input<string>('');
}
